import { NotificationsStoreContext } from '../notifications-context';
import { createContextStoreHooks } from '@/shared/libs/create-context-store-hooks';

export interface NotificationsState {
  notifications: any;
  isNotifyLoading: boolean;
  supportRefreshSignal: any;
  messageSignal: { sequence: number; raw: string } | null;
}

// NotificationsStoreContext объявлен как createContext(null) без типа (см. notifications-context.tsx),
// поэтому кастуем именно аргумент — как и в user-provider/store, но с сохранением
// типизации состояния на самих селекторах (там не было своего типа, тут он есть)
const { useSelector: useNotificationsSelector } =
  createContextStoreHooks<NotificationsState>(NotificationsStoreContext as any);

// Подписка на срез notifications через внешний стор — не ре-рендерит на изменения других полей, в отличие от useNotifications()
export { useNotificationsSelector };

// Готовые именованные селекторы на каждое поле notifications — единая точка правды
// вместо useNotificationsSelector((s) => s.notifications?.поле), разбросанного по компонентам
export const useIsNotifyLoading = () =>
  useNotificationsSelector((s) => s.isNotifyLoading);
export const useSupportRefreshSignal = () =>
  useNotificationsSelector((s) => s.supportRefreshSignal);
export const useNotificationMessageSignal = () =>
  useNotificationsSelector((s) => s.messageSignal);
export const useBalance = () =>
  useNotificationsSelector((s) => s.notifications?.balance);
export const useGoldCard = () =>
  useNotificationsSelector((s) => s.notifications?.goldCard);
export const useGoldCardTimer = () =>
  useNotificationsSelector((s) => s.notifications?.goldCardTimer);
export const useNotificationsConfirmed = () =>
  useNotificationsSelector((s) => s.notifications?.confirmed);
export const useNotificationsPaymentError = () =>
  useNotificationsSelector((s) => s.notifications?.paymentError);
export const useNotificationsTransaction = () =>
  useNotificationsSelector((s) => s.notifications?.transaction);
export const useTransactionBonusID = () =>
  useNotificationsSelector((s) => s.notifications?.transaction?.bonusID);
export const useTransactionStatus = () =>
  useNotificationsSelector((s) => s.notifications?.transaction?.status);
export const useNotificationsBonus = () =>
  useNotificationsSelector((s) => s.notifications?.bonus);
export const useIsBonusActive = () =>
  useNotificationsSelector((s) => s.notifications?.bonus?.isActive);
export const useBonusBalance = () =>
  useNotificationsSelector((s) => s.notifications?.bonus?.bonusBalance);
export const useBonusWager = () =>
  useNotificationsSelector((s) => s.notifications?.bonus?.wager);
export const useBonusStartWager = () =>
  useNotificationsSelector((s) => s.notifications?.bonus?.startWager);
export const useBonusProvider = () =>
  useNotificationsSelector((s) => s.notifications?.bonus?.provider);
export const useBonusInfoGames = () =>
  useNotificationsSelector((s) => s.notifications?.bonusInfo?.games);
export const useBonusInfoProvider = () =>
  useNotificationsSelector((s) => s.notifications?.bonusInfo?.provider);
export const useOnboardingPopup = () =>
  useNotificationsSelector((s) => s.notifications?.onboardingPopup);
